import type { Tier, TileRef, Viewport } from "./types";

export function tileIndexAt(tsMs: number, tier: Tier): number {
  return Math.floor(tsMs / tier.tileSpanMs);
}

export function tilesForViewport(viewport: Viewport, tier: Tier, overscanTiles: number): TileRef[] {
  const first = tileIndexAt(viewport.startMs, tier) - overscanTiles;
  // endMs is exclusive ([startMs, endMs)); an endMs exactly on a tile boundary
  // must map to the tile that ends there, not pull in the next (empty) tile.
  const last = Math.ceil(viewport.endMs / tier.tileSpanMs) - 1 + overscanTiles;
  const refs: TileRef[] = [];
  for (let i = first; i <= last; i++) {
    refs.push({ tierId: tier.id, index: i, startMs: i * tier.tileSpanMs, endMs: (i + 1) * tier.tileSpanMs });
  }
  return refs;
}
